import { BuyerCard } from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content, useContent } from 'src/contexts/ContentContext';
import { Button, Stack } from 'src/core/ui';
import { SectionContent } from 'src/modals/common/Detail/Detail.styled';
import { DetailSection } from 'src/modals/common/DetailSection';
import { useRetailSaleContext } from 'src/modals/RetailSale/RetailSaleLocalContext';
import { useRetailSaleStep } from 'src/modals/RetailSale/RetailSaleLocalContext.atoms';
import { ContentId } from 'src/utils/constants/contentId';

import { RetailSaleEarningsSection } from './RetailSaleCheckoutStep.components';
import { RetailSalePaymentSection } from './RetailSalePaymentSection';

export const RetailSaleCheckoutStep = () => {
  const { selectedBuyer, disabled } = useRetailSaleContext();
  const { goToDetail } = useRetailSaleStep();
  const customerInfoMsg = useContent(ContentId.CustomerInfo);

  return (
    <Stack direction="column" gap="l">
      {selectedBuyer && (
        <DetailSection
          name={
            <Stack
              direction="row"
              justifyContent="spaceBetween"
              alignItems="center"
              width="full"
            >
              {customerInfoMsg}
              <Button variant="link" size="unset" onClick={goToDetail}>
                <Content id={ContentId.Change} />
              </Button>
            </Stack>
          }
        >
          <SectionContent numOfColumns={1}>
            <BuyerCard buyer={selectedBuyer} />
          </SectionContent>
        </DetailSection>
      )}

      <RetailSaleEarningsSection disabled={disabled} />

      <RetailSalePaymentSection />
    </Stack>
  );
};
